// ** React Imports
import { useEffect, useState } from 'react';

import { client } from 'src/utils/axios-client';
import {
    LeadScreenStore,
    LeadActivity,
    Lead,
    NextActivity,
    LeadAccountStore,
    ViewType,
    ActivityDialogStore,
} from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import _ from 'lodash';
import LeadDataFormater from './LeadDataFormater';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadialBarChart from '../../common/RadialBarChart';
import Skeleton from '@mui/material/Skeleton';
import StandardSkeleton from '../../common/StandardSkeleton';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityAccountInfo = () => {
    const accountRecord = LeadAccountStore.useState((s) => s.record);
    const selectedLead = LeadScreenStore.useState((s) => s.selectedLead);
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const fetchAccountDetails = async () => {
            setHasLoaded(false);
            debugger;
            const response = await client.get(
                leadEndpoints.getLeadAccount.replace(
                    '{accountid}/{sprintid}',
                    selectedLead?.account?.id + '/' + selectedLead?.sprint?.id,
                ),
            );
            LeadAccountStore.update((s) => {
                s.record = response.data;
            });
            setHasLoaded(true);
        };
        if (selectedLead != null && selectedLead.account != null && selectedLead.sprint != null) {
            fetchAccountDetails();
        } else {
            setHasLoaded(true);
        }

        //if (!selectedLead) LeadAccountStore.update(s => { s = null });
    }, [selectedLead]);

    const viewAccountLeads = () => {
        ActivityDialogStore.update((s) => {
            s.accountLeadMode = true;
        });
    };

    const viewSprintLeads = () => {
        ActivityDialogStore.update((s) => {
            s.sprintLeadMode = true;
        });
    };

    if (hasLoaded) {
        return (
            <Box>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Box>
                                    <Grid container spacing={2} alignContent={'flex-end'}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}
                                        >
                                            <Grid item xs={12} sx={{ alignItems: 'right' }} justifyContent={'flex-end'}>
                                                <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                                                    Account
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                md={12}
                                                sx={{ alignItems: 'right' }}
                                                justifyContent={'flex-end'}
                                            >
                                                <Grid item xs={12}>
                                                    <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                        {selectedLead?.account && (
                                                            <Typography sx={{ fontSize: 16 }} gutterBottom>
                                                                {selectedLead.account.name}
                                                            </Typography>
                                                        )}
                                                        {!selectedLead?.account && (
                                                            <Box>
                                                                <Typography
                                                                    sx={{ fontSize: 16, fontStyle: 'italic' }}
                                                                    gutterBottom
                                                                >
                                                                    -Account Missing-
                                                                </Typography>
                                                                <Typography
                                                                    sx={{ fontSize: 12, fontStyle: 'italic' }}
                                                                    variant="caption"
                                                                    gutterBottom
                                                                >
                                                                    Edit lead to add an account
                                                                </Typography>
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            {selectedLead?.account && (
                                                <Box>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={12}
                                                        sx={{ alignItems: 'right' }}
                                                        justifyContent={'flex-end'}
                                                    >
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <Tooltip title="All leads related to this account">
                                                                <Link
                                                                    underline="hover"
                                                                    component="button"
                                                                    variant="caption"
                                                                    onClick={viewAccountLeads}
                                                                >
                                                                    Account Leads ({accountRecord.leadCount})
                                                                </Link>
                                                            </Tooltip>
                                                        </Box>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={12}
                                                        sx={{ alignItems: 'right' }}
                                                        justifyContent={'flex-end'}
                                                    >
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <Tooltip title="All leads related to this account and sprint">
                                                                <Link
                                                                    underline="hover"
                                                                    component="button"
                                                                    variant="caption"
                                                                    onClick={viewSprintLeads}
                                                                >
                                                                    Sprint Leads ({accountRecord.leadSprintCount})
                                                                </Link>
                                                            </Tooltip>
                                                        </Box>
                                                    </Grid>
                                                </Box>
                                            )}
                                        </Grid>
                                        {selectedLead?.account && (
                                            <Grid
                                                item
                                                xs={12}
                                                md={6}
                                                sx={{ alignItems: 'right' }}
                                                justifyContent={'flex-end'}
                                            >
                                                <Box display="flex" justifyContent="flex-end">
                                                    <RadialBarChart
                                                        subHeading="Contact Rate"
                                                        seriesValue={accountRecord.connectionRate}
                                                        toolTip="Contact Rate of meanigful Interactions for this account"
                                                    />
                                                </Box>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                                {selectedLead?.account && (
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography variant="caption">Additional details...</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Box>
                                                <Grid container spacing={2} justifyContent={'center'}>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="Industry:"
                                                                valueText={accountRecord.industryName}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="Annual Revenue:"
                                                                valueText={accountRecord.revenueAmount}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="Employee Size:"
                                                                valueText={accountRecord.employeeSize}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="Account Status:"
                                                                valueText={accountRecord.accountStatusName}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="HQ Address:"
                                                                valueText={accountRecord.hqAddress}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="HQ City:"
                                                                valueText={accountRecord.hqCity}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="HQ Province:"
                                                                valueText={accountRecord.hqProvince}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="HQ PostalCode:"
                                                                valueText={accountRecord.hqPostalCode}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="HQ Country:"
                                                                valueText={accountRecord.hqCountryName}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}>
                                                        <Box sx={{ display: 'flex', mb: 0.7, alignItems: 'center' }}>
                                                            <LeadDataFormater
                                                                labelText="HQ Region:"
                                                                valueText={accountRecord.hqRegionName}
                                                                textColor=""
                                                                errorText="-Unknown-"
                                                                chipHeight={20}
                                                                chipFontSize="0.75rem"
                                                                chipfontWeight={500}
                                                                isChip={false}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        );
    } else {
        return <StandardSkeleton />;
    }
};

export { DoActivityAccountInfo };

export default DoActivityAccountInfo;
